import { createSelector } from 'reselect';
import { playerModalSelector } from './simple-selector';

export const playerModalRequestsSelector = createSelector(
    playerModalSelector,
    (playerModal) => playerModal.requests
);
